export const BACKEND_DEVELOPMENT_URL = 'http://localhost:5001';